var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWixIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 10,
    viewBox: "0 0 27 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.499 0H25.0629C24.6645 0 24.2922 0.195989 24.0683 0.523748L22.1477 3.33847C22.0965 3.41313 21.9856 3.41313 21.9345 3.33847L20.0137 0.523748C19.7903 0.195989 19.4176 0 19.0192 0H17.583L21.0046 5.01397L17.6019 10H19.0381C19.4365 10 19.8089 9.80402 20.0327 9.47625L21.9345 6.68947C21.9856 6.61483 22.0965 6.61483 22.1477 6.68947L24.0495 9.47625C24.2728 9.80402 24.6456 10 25.044 10H26.4802L23.0776 5.01397L26.499 0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6279 1.02289V10H15.3143C15.8832 10 16.3442 9.54214 16.3442 8.97711V0H15.6577C15.0889 0 14.6279 0.457863 14.6279 1.02289Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3703 0H12.7594C12.0869 0 11.5042 0.462033 11.3552 1.11338L9.98866 7.08102L8.7926 1.51036C8.57136 0.480797 7.50798 -0.213502 6.41982 0.0850673C5.72669 0.275217 5.21284 0.856928 5.06296 1.5554L3.8791 7.07352L2.5151 1.1138C2.36565 0.46245 1.78295 0 1.11041 0H0.5L2.78925 9.99958H3.65658C4.44373 9.99958 5.12383 9.45291 5.28799 8.68813L6.75147 1.86564C6.76951 1.781 6.84592 1.71969 6.93282 1.71969C7.01972 1.71969 7.09612 1.781 7.11418 1.86564L8.57891 8.68855C8.74306 9.45331 9.42316 9.99958 10.2103 9.99958H11.0806L13.3703 0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWixIcon);
export default __webpack_public_path__ + "static/media/wix_icon.e93256cf14c5353a03499c29cb57f9a1.svg";
export { ForwardRef as ReactComponent };